import(/* webpackMode: "eager" */ "/home/aries/adlily/apps/v2/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Rubik\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-sans\"}],\"variableName\":\"sans\"}");
;
import(/* webpackMode: "eager" */ "/home/aries/adlily/apps/v2/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/aries/adlily/apps/v2/src/components/sonner.tsx");
